import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Services
import { NavigationParam, RouteParam, ServiceBase } from '../service-base';

// Modèles
import { BankStatement } from 'src/app/@shared/models/banking/statements/bank-statement.model';

const CLASS_NAME = 'BankStatement';
const ENDPOINT = `/bank-statements/`;
const NAVIGATIONS: NavigationParam[] = [
    { key: 'lines', path: 'lines/', childClass: 'BankStatementLine' },
]
const ROUTES: RouteParam[] = [
    { key: 'massDelete', path: 'mass-delete/' },
    { key: 'triggerOcrOnly',        path: '{id}/trigger-ocr-only/' },
    { key: 'triggerReconciliation', path: '{id}/trigger-reconciliation/' },
    { key: 'triggerTransactionsImport', path: '{id}/trigger-transactions-import/' },
    { key: 'triggerQualification', path: '{id}/trigger-qualification/' },
    { key: 'replaceFile',           path: '{id}/replace-file/' },
    { key: 'resumeAfterCorrection', path: '{id}/resume-after-correction/' },
]

@Injectable({
    providedIn: 'root'
})
export class BankStatementService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addNavigations(NAVIGATIONS);
        this.addRoutes(ROUTES);
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes publiques
     ----------------------------------------------------------------------------------------*/

    /** Déclenche le pipeline OCR seul (analyze → OCR → ocr_done) */
    public triggerOcrOnly$(id: number): Observable<BankStatement> {
        const url = this.routes['triggerOcrOnly'].replace('{id}', id.toString());
        return this._postAction$<BankStatement>(url);
    }

    /** Déclenche le pipeline de réconciliation (analyze → OCR → matching) */
    public triggerReconciliation$(id: number): Observable<BankStatement> {
        const url = this.routes['triggerReconciliation'].replace('{id}', id.toString());
        return this._postAction$<BankStatement>(url);
    }

    /** Déclenche le pipeline d'import des transactions (analyze → OCR → import) */
    public triggerTransactionsImport$(id: number): Observable<BankStatement> {
        const url = this.routes['triggerTransactionsImport'].replace('{id}', id.toString());
        return this._postAction$<BankStatement>(url);
    }

    /**
     * Met en file la qualification IA puis le rapprochement automatique sur le compte
     * bancaire du relevé (fin de « Tout importer » du pointage, #1120).
     * Réponse 202 sans valeur : seuls les messages sont relayés.
     */
    public triggerQualification$(id: number): Observable<void> {
        const url = this.routes['triggerQualification'].replace('{id}', id.toString());
        return this._postActionValue$<void>(url);
    }

    /** Remplace le fichier PDF (status analysis_failed ou ocr_failed → uploaded) */
    public replaceFile$(id: number, attachment: string, attachmentName: string): Observable<BankStatement> {
        const url = this.routes['replaceFile'].replace('{id}', id.toString());
        return this._postAction$<BankStatement>(url, { attachment, attachmentName });
    }

    /** Reprend le pipeline après correction manuelle (consistency_warning) */
    public resumeAfterCorrection$(id: number): Observable<BankStatement> {
        const url = this.routes['resumeAfterCorrection'].replace('{id}', id.toString());
        return this._postAction$<BankStatement>(url);
    }
}
